/**
 * 品牌目录页：字母锚点平滑滚动、滚动时高亮当前字母；锚点不存在时跳到最接近的字母
 */
class BrandDirectory extends HTMLElement {
  connectedCallback() {
    this.groups = Array.from(this.querySelectorAll('[data-brand-group]'));
    this.letterLinks = Array.from(this.querySelectorAll('[data-letter-link]'));

    this.onLetterClick = this.onLetterClick.bind(this);
    this.letterLinks.forEach((link) => link.addEventListener('click', this.onLetterClick));

    this.observeGroups();
    this.handleInitialHash();
  }

  disconnectedCallback() {
    this.letterLinks.forEach((link) => link.removeEventListener('click', this.onLetterClick));
    if (this.observer) this.observer.disconnect();
  }

  onLetterClick(event) {
    const href = event.currentTarget.getAttribute('href') || '';
    if (!href.startsWith('#')) return;

    event.preventDefault();
    if (this.scrollToLetter(event.currentTarget.dataset.letterLink)) {
      if (history.replaceState) history.replaceState(null, '', href);
    }
  }

  // 从超级菜单跳进来时，字母可能没有对应分组，就落到最接近的下一个字母
  handleInitialHash() {
    const match = /^#brands_(.+)$/.exec(window.location.hash || '');
    if (!match) return;
    const letter = match[1] === 'other' ? '#' : decodeURIComponent(match[1]).toUpperCase();
    if (document.getElementById(`brands_${match[1]}`)) return;
    this.scrollToLetter(letter);
  }

  scrollToLetter(letter) {
    const group = this.findGroup(letter);
    if (!group) return false;

    const target = group.querySelector('.brand-group-letter') || group;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    this.setActiveLetter(group.dataset.letter);
    return true;
  }

  findGroup(letter) {
    const exact = this.groups.find((group) => group.dataset.letter === letter);
    if (exact) return exact;
    // 没有该字母时，取字母表中排在其后的第一个分组
    return this.groups.find((group) => group.dataset.letter > letter) || null;
  }

  setActiveLetter(letter) {
    this.letterLinks.forEach((link) => {
      link.classList.toggle('is-active', link.dataset.letterLink === letter);
    });
  }

  observeGroups() {
    if (!('IntersectionObserver' in window) || this.groups.length === 0) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (visible.length === 0) return;
        this.setActiveLetter(visible[0].target.dataset.letter);
      },
      { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    );

    this.groups.forEach((group) => this.observer.observe(group));
  }
}

if (!customElements.get('brand-directory')) {
  customElements.define('brand-directory', BrandDirectory);
}
